import { render, staticRenderFns } from "./shareWarn.vue?vue&type=template&id=c7f56d0e&scoped=true&"
import script from "./shareWarn.vue?vue&type=script&lang=js&"
export * from "./shareWarn.vue?vue&type=script&lang=js&"
import style0 from "./shareWarn.vue?vue&type=style&index=0&id=c7f56d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f56d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
